import styled, { css } from 'styled-components';
import AntSelect from 'antd/lib/select';
import { colors } from '@10d/tend-ui-tokens/samolet';

import SamoletButton from '../Buttons';

export const defaultStyles = css`
  border-radius: 8px;
  background-color: ${colors.gray0};
  color: ${colors.gray900};

  .ant-select,
  .ant-select-dropdown,
  .ant-select:not(.ant-select-customize-input) .ant-select-selector {
    font-family: 'Museo Sans Cyrl', sans-serif;
    border-radius: 8px;
    color: inherit;
  }

  .ant-select-dropdown {
    box-shadow:
      0 8px 22px -6px #18274b0a,
      0px 14px 64px -4px #18274b0a;
    padding: 0;

    .ant-select-item {
      display: flex;
      align-items: center;
      min-height: 30px;
      padding: 8px 16px;
    }

    .ant-select-item-option-content {
      color: ${colors.gray900};
    }

    .ant-select-item-option-active:not(.ant-select-item-option-disabled) {
      background-color: #f7f9fe;
    }

    .ant-select-item-option-selected:not(.ant-select-item-option-disabled) {
      background: ${colors.blue100};
      font-weight: 400;
    }
  }
`;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const Select = styled(AntSelect as any)`
  ${defaultStyles};
  width: ${props => (props.fullWidth ? '100%' : 'auto')};
  box-sizing: border-box;

  && .ant-select-selector {
    border-color: #bdc5db;
    border-radius: 8px;
  }

  && .ant-select-selection-item {
    font-family: 'Museo Sans Cyrl';
    ${props =>
      props.mode === 'multiple' &&
      `
        border-radius: 4px;
        background: ${colors.gray650};
        color: ${colors.gray0};
        height: auto;
        padding-top:${props.size !== 'small' ? '2px' : 0};
        padding-bottom:${props.size !== 'small' ? '2px' : 0};
        border: none;
      `}

    && .ant-tag,
    .ant-tag-close-icon,
    .ant-select-selection-item,
    .ant-select-selection-item-remove {
      color: ${colors.gray0};
      font-size: 14px !important;
    }
  }

  &.ant-select-disabled.ant-select-single:not(.ant-select-customize-input) {
    .ant-select-selector {
      border-color: #bdc5db;
      background: #eaedf5;
    }
  }

  && .ant-tag,
  .ant-tag-close-icon {
    color: ${colors.gray0};
  }

  && .ant-select-arrow,
  && .ant-select-selection-placeholder {
    font-family: 'Museo Sans Cyrl';
    color: ${colors.gray400};
  }

  .ant-select-arrow,
  .ant-select-clear {
    font-size: 16px;
    width: 16px;
    height: 16px;
    margin-top: -8px;
    right: 8px;
  }

  && .anticon-down.ant-select-suffix {
    margin-top: ${props => (props.dropdownvisible ? -1 : 0)}px;
    transform: rotate(${props => (props.dropdownvisible ? 180 : 0)}deg);
    transition: transform 0.3s;
  }

  &&.ant-select:not(.ant-select-disabled) {
    & .ant-select-selector {
      border-color: ${({ $hasError }) => $hasError && colors.red600};
    }

    &:hover .ant-select-selector {
      border-color: ${({ $hasError }) => ($hasError ? colors.red600 : colors.blue500)};
    }

    &:focus .ant-select-selector {
      border-color: ${({ $hasError }) => $hasError && colors.red600};
      box-shadow: ${({ $hasError }) => $hasError && `0 0 0 2px ${colors.red600}`};
      border-right-width: 1px;
      outline: 0;
    }
  }

  &.ant-select-focused .ant-select-selector {
    box-shadow: ${({ $hasError }) => $hasError && '0 0 0 2px rgba(255, 77, 79, 0.2) !important'};
  }

  .dropDownRender .ant-select-item-option-content {
    white-space: initial;
  }

  && .ant-select-item-option-disabled {
    opacity: 0.4;
  }
`;

export const highlightStyle = {
  paddingLeft: 0,
  paddingRight: 0,
  background: colors.gold200,
};

export const Action = styled.div`
  align-items: center;
  border-bottom: 1px solid ${colors.gray50};
  color: ${colors.blue600};
  cursor: pointer;
  display: flex;
  padding: 5px 0 5px 16px;
  line-height: 24px;

  &:hover {
    background-color: #eaedf5;
  }
`;

export const EmptyWrapper = styled.div`
  & .ant-empty {
    margin: 0;
  }

  & .ant-empty-image svg {
    width: 100%;
  }
`;

export const Button = styled(SamoletButton)`
  display: block;
  margin: 0 auto;
  width: 95%;
`;
